import { useNetworkStatusContext } from "../contexts/NetworkStatusContext";
import NoInternet from "../assets/No internet.svg";
export function NoInternetOverlay() {
  const { isOnline } = useNetworkStatusContext();

  if (isOnline) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex items-center justify-center p-4">
      {/* Content Container */}
      <div className="flex flex-col items-center justify-center gap-8 max-w-lg w-full">
        {/* SVG Icon - No Internet */}
        <div className="w-64 h-64 sm:w-80 sm:h-80 flex items-center justify-center">
          <img
            src={NoInternet}
            alt="No Internet Connection"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Text Content - Minimal */}
        <div className="text-center space-y-2">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
            No Internet Connection
          </h1>
          <p className="text-gray-600 text-sm sm:text-base">
            Please check your network and try again.
          </p>
          <p className="text-gray-500 text-xs sm:text-sm mt-4">
            The application will automatically reconnect when your internet is
            restored.
          </p>
        </div>
      </div>
    </div>
  );
}
